import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmationPopupComponent } from '../popups/confirmation-popup/confirmation-popup.component';


type confirmationData = {
  msgTitle?: string,
  msg?: string,
  btn1?: string,
  btn2?: string,
  btn2BgColor?: string,
  showSuccessIcon?: boolean,
  showSuccessMessage?: boolean,
  showCloseIcon?: boolean,
}

type errorData = {
  msg?: string,
  btn2?: string,
}

@Injectable({
  providedIn: 'root'
})

export class AllPopupModalExecutionServiceService {
  
  constructor(private dialog: MatDialog) { }
  
  confirmationPopupComponentExe(modalData: confirmationData) {
    return this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 575.98 ? '90%' : window.innerWidth <= 991.98 ? '50%' : '30%',
      data: {
        msgTitle: modalData?.msgTitle || '',
        msg: modalData?.msg || '',
        btn1: modalData?.btn1 || 'Cancel',
        btn2: modalData?.btn2 || 'Yes',
        btn2BgColor: modalData?.btn2BgColor || '#F6921E',
        showSuccessIcon: modalData?.showSuccessIcon || false,
        showSuccessMessage: modalData?.showSuccessMessage || false,
        showCloseIcon: modalData?.showCloseIcon || false
      },
    });
  }
  
  apiSuccessOrErrorMessage(modalData: errorData){
    this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 575.98 ? '90%' : window.innerWidth <= 991.98 ? '50%' : '30%',
      data: {
        msgTitle: '',
        msg: modalData?.msg || '',
        btn1: '',
        btn2: modalData?.btn2 || 'OK',
        btn2BgColor: '#F6921E',
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
  }
}
